// Translates backend failures into a small set of teacher-facing situations.

import { ContractError } from "./adapter";

export const OFFLINE = "offline";
export const DENIED = "denied";
export const UNAVAILABLE = "unavailable";
export const UNKNOWN = "unknown";

// Problems that may clear up on their own, so it is worth checking again.
export const RETRYABLE = new Set([OFFLINE, UNKNOWN]);

export const problemOf = (error) => {
  if (navigator.onLine === false || error instanceof TypeError) return OFFLINE;
  if (error instanceof ContractError) return UNAVAILABLE;
  const status = error?.response?.status;
  if (status === 401 || status === 403) return DENIED;
  return UNKNOWN;
};
